import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useLocation } from "react-router-dom";

const PaymentSuccess = () => {
  const [status, setStatus] = useState("Verifying payment...");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paymentId = queryParams.get("payment_id");

  const hasRun = useRef(false);

  useEffect(() => {
    const verifyAndCapture = async () => {
      try {
        const res = await axios.get(
          `https://365luxuryhomes.com/api/get-payment/${paymentId}`
        );
        const amount = Number(res?.data?.amount || 0).toFixed(2);
        const paymentStatus = res?.data?.status;

        const payload = {
          amount,
        };

        if (paymentStatus === "AUTHORIZED") {
          await axios.post(
            `https://365luxuryhomes.com/api/capture-payment/${paymentId}`,
            payload
          );
          setStatus("✅ Payment captured! Reservation confirmed.");
        } else if (paymentStatus === "CANCELLED") {
          setStatus("❌ Payment was cancelled.");
        } else {
          setStatus(`⚠️ Payment status: ${paymentStatus}`);
        }
      } catch (err) {
        console.error(err);
        setStatus("❌ Error verifying payment.");
      }
    };

    // 3. Check the paymentId AND the ref guard
    if (paymentId && !hasRun.current) {
      verifyAndCapture();
      hasRun.current = true;
    }
  }, [paymentId]);

  return (
    <>
      <Helmet>
        <title>Payment Success - 365LuxuryHomes</title>
        <meta
          name="description"
          content="Your payment has been successfully processed. Thank you for your reservation!"
        />
        <link rel="canonical" href="http://localhost:5000/payment-success" />
      </Helmet>
      <div className="w-full h-dvh">
        <div className="flex max-w-screen-sm px-4 mx-auto items-center justify-center flex-col h-full">
          <h1 className="lg:text-2xl md:text-2xl text-xl font-bold leading-none text-center text-[#74716d]">
            Thank you for booking with <br />
            365 Luxury Homes.
          </h1>
          <p className="text-center lg:mt-4 md:mt-3 mt-2 text-[#74716d]">
            Your reservation is confirmed, and we’re delighted to host you.
            <br /> You will receive your booking details, detailed itinerary,
            check-in instructions, and your dedicated concierge’s contact
            information via email shortly.
          </p>
          <p className="text-center lg:mt-4 md:mt-3 mt-2 text-[#74716d]">
            If you need any assistance before your arrival, our guest services
            team is available 24/7 via{" "}
            <a
              href="https://wa.me/971521434186"
              target="_blank"
              className="underline"
            >
              WhatsApp
            </a>{" "}
            or{" "}
            <a href="tel:+971521434186" target="_blank" className="underline">
              Phone
            </a>
          </p>
          <Link
            to={"/"}
            className="btn btn-sm bg-[#c3a963] text-white hover:text-[#c3a963] hover:bg-[#ffffff] hover:no-underline font-thin mt-4 h-[50px] px-4"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default PaymentSuccess;
